const AUTH_STORAGE_KEYS = new Set([
  'user',
  'role',
  'id',
  'role_id',
  'userPermissions',
]);

export const DEFAULT_SESSION_REFRESH_INTERVAL_MS = 5 * 60 * 1000;
export const DEFAULT_SESSION_REFRESH_COOLDOWN_MS = 1000;

export function installSessionSync({
  store,
  windowObject = window,
  documentObject = document,
  intervalMs = DEFAULT_SESSION_REFRESH_INTERVAL_MS,
  cooldownMs = DEFAULT_SESSION_REFRESH_COOLDOWN_MS,
  clock = () => Date.now(),
}) {
  let stopped = false;
  let refreshPromise = null;
  let lastRefreshStartedAt = Number.NEGATIVE_INFINITY;

  const refreshSession = () => {
    if (stopped || documentObject.visibilityState === 'hidden') {
      return Promise.resolve(null);
    }

    if (refreshPromise) {
      return refreshPromise;
    }

    const now = clock();
    if (now - lastRefreshStartedAt < cooldownMs) {
      return Promise.resolve(null);
    }

    lastRefreshStartedAt = now;
    refreshPromise = Promise.resolve(store.dispatch('restoreSession'))
      .finally(() => {
        refreshPromise = null;
      });
    return refreshPromise;
  };

  const handleFocus = () => refreshSession();
  const handleVisibilityChange = () => {
    if (documentObject.visibilityState === 'visible') {
      refreshSession();
    }
  };
  const handleStorage = (event) => {
    if (event.key === null || AUTH_STORAGE_KEYS.has(event.key)) {
      refreshSession();
    }
  };

  windowObject.addEventListener('focus', handleFocus);
  windowObject.addEventListener('storage', handleStorage);
  documentObject.addEventListener(
    'visibilitychange',
    handleVisibilityChange,
  );
  const intervalId = windowObject.setInterval(refreshSession, intervalMs);

  return () => {
    stopped = true;
    windowObject.removeEventListener('focus', handleFocus);
    windowObject.removeEventListener('storage', handleStorage);
    documentObject.removeEventListener(
      'visibilitychange',
      handleVisibilityChange,
    );
    windowObject.clearInterval(intervalId);
  };
}
